<template>
  <div>
    <div class="row">
      <div class="col-sm-3">
        <card v-if="producer" class="m-0" gradient="default">
          <h3 class="card-title text-white m-0">{{ producer.businessName }}</h3>

          <blockquote class="blockquote text-white m-0">
            <footer class="text-danger">
              <small><span>CUIT</span>&nbsp;{{ producer.cuit }}</small>
            </footer>
          </blockquote>
        </card>
      </div>

      <div class="col-sm-3">
        <card v-if="field" class="m-0" gradient="danger">
          <h3 class="card-title text-white m-0">{{ field.name }}</h3>

          <blockquote class="blockquote text-white m-0">
            <footer class="text-primary">
              <small>{{ field.hectares }}&nbsp;has.</small>
            </footer>
          </blockquote>
        </card>
      </div>

      <div class="col-sm-3">
        <card v-if="plot" class="m-0" gradient="success">
          <h3 class="card-title text-white m-0">{{ plot.name }}</h3>

          <blockquote class="blockquote text-white m-0">
            <footer class="text-default">
              <small>{{ plot.variety.name }} | {{ plot.hectares }}&nbsp;has.</small>
            </footer>
          </blockquote>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    producer: null,
    field: null,
    plot: null,
  },
};
</script>

<style scoped>
.card .card-body {
  padding: 0.5rem !important;
}
</style>
